import { Box, FormControl, Typography } from '@mui/material'
import { ContainerPositionType, JourneyCategory } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { ContainerPositionRadio } from '../equipmentOperator/components/Stepper/ContainerPositionRadio'

interface Props {
  vesselVisitId?: number | null
  craneName?: string
  showAlert?: boolean
  journeyCategory: JourneyCategory
}

export const TallymanEquipmentSelector = observer(
  ({ vesselVisitId, journeyCategory, craneName, showAlert }: Props) => {
    const { tallymanOperationsUIStore } = useOperationsStore()
    const theme = useMinimalsTheme()
    const { t } = useTranslate()
    const [containerPositionType, setContainerPositionType] = useState<
      ContainerPositionType | undefined
    >()
    const [id, setId] = useState<number | undefined>()

    useEffect(() => {
      if (!vesselVisitId) return
      tallymanOperationsUIStore.selectEquipment()
      tallymanOperationsUIStore.selectContainerPosition()
    }, [vesselVisitId, tallymanOperationsUIStore])

    const handleDestinationChange = (eqId?: number, containerPosition?: ContainerPositionType) => {
      setId(eqId)
      tallymanOperationsUIStore.selectEquipment(eqId)

      setContainerPositionType(containerPosition)
      tallymanOperationsUIStore.selectContainerPosition(containerPosition)
    }

    return (
      <Box sx={{ padding: theme.customSpacing.m }}>
        <FormControl sx={{ width: '100%' }}>
          <ContainerPositionRadio
            equipmentId={id}
            containerPositionType={containerPositionType}
            hasError={showAlert && !id && !containerPositionType}
            equipments={tallymanOperationsUIStore.items.map(equipment => ({
              id: equipment.id,
              type: equipment.equipmentType,
              title: equipment.name,
            }))}
            craneName={craneName}
            showVessel={journeyCategory === JourneyCategory.Restow}
            showBerth={
              journeyCategory === JourneyCategory.Restow ||
              journeyCategory === JourneyCategory.Overlanded
            }
            onDestinationChange={handleDestinationChange}
          />
          {!tallymanOperationsUIStore.items.length && (
            <Typography variant='subtitle1'>
              {t('noEquipmentAssigned', 'No equipment assigned')}
            </Typography>
          )}
        </FormControl>
      </Box>
    )
  },
)
